import { render } from "./SwimmingPool.vue?vue&type=template&id=61f2563f&scoped=true"
import script from "./SwimmingPool.vue?vue&type=script&lang=js"
export * from "./SwimmingPool.vue?vue&type=script&lang=js"

import "./SwimmingPool.vue?vue&type=style&index=0&id=61f2563f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Htet Win Khant\\Desktop\\Light Idea\\WebFlashMallRestaurant360DegreeRestaurant-\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f2563f"]])

export default __exports__